import { createFileRoute } from "@tanstack/react-router";
import { OpportunityDetailPage } from "@/features/opportunities/opportunity-detail-page";

export const Route = createFileRoute("/_authenticated/opportunities/$opportunityId")({
  head: () => ({ meta: [{ title: "Opportunity · Rogue Admin" }] }),
  component: OpportunityDetailPage,
});
